import { BebyggelseobjektPublicerad, BebyggelseobjektPubliceradIndex, BebyggelseobjektVersionHistorisk } from 'models';

import { BebyggelseklassEnum } from 'enums';

// Stödfunktion för att "omvandla" ingående objekt till Publicerade. Vi gör detta "hack" för att kringgå type-contrainten
// i replaceBebyggelseobjektFeaturesInActiveSource så alla ingående objekt också markeras i aktiva lagret i kartan
export const getIngaendeAsPublicerade = (
  bebyggelseobjekt: BebyggelseobjektPublicerad | BebyggelseobjektVersionHistorisk
): BebyggelseobjektPubliceradIndex[] => {
  return (
    bebyggelseobjekt.sammansatt?.ingaendeobjekt.map((ingaendeObjekt) => ({
      id: ingaendeObjekt.id,
      bebyggelsenummer: ingaendeObjekt.bebyggelsenummer,
      titel: ingaendeObjekt.titel,
      geometri: ingaendeObjekt.geometri,
      // Fält som behöver placeholder värden som vi delvis lånar från Sammansatta föräldern
      bebyggelseklass: BebyggelseklassEnum.BYGGNAD,
      bebyggelseklasstyp_namn: BebyggelseklassEnum.BYGGNAD,
      skyddstyp: bebyggelseobjekt.skydd.skyddstyp,
      skyddstyp_namn: bebyggelseobjekt.skydd.skyddstyp_namn,
      berorda_fastigheter: [],
      publiceringsdatum: bebyggelseobjekt.publiceringsdatum,
      skydd: bebyggelseobjekt.skydd,
      ursprungligt_primar_andamal: bebyggelseobjekt.ursprungligt_primar_andamal,
      havt_skydd: bebyggelseobjekt.sammansatt?.havt_skydd || false
    })) || []
  );
};
